import { useFormContext } from "react-hook-form";
import { TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { TimeAndDayFormData } from "../../types";

export const TimeStartField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<TimeAndDayFormData>();
  const allDay = watch("allDay");

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="action">Time Start</Typography>
      <TextInput placeholder="00 : 00" type="time" step={1} hasError={!!errors.timeStart} disabled={allDay} {...register("timeStart")} />
    </div>
  );
};
